module.exports = {

  slug: 'favourites',

  init() {

    this.addToFavouritesListener()

    this.removeFavouritesListener()

  },
  /** 
   * @return null - add listener
   */
  addToFavouritesListener() {

    $('.add-to-favourites').click((e)=>{

      const isPropertySaved = (
        $(e.target).attr('property-saved') == "true" || 
        $(e.target).attr('property-saved') == "1");

      if (isPropertySaved) {
        this.removeItem($(e.target).attr('property-id'), $(e.target))
      } else {
        this.addItem($(e.target).attr('property-id'), $(e.target))
      }

    })    

  },
  /**
   * @return null - remove item
   */
  removeFavouritesListener() {

    $('.remove-favourite').click((e)=>{

      this.removeItem($(e.target).attr('property-id'), null)

      $(e.target).closest('.property-intro').remove() 

    })

  },
  /**
   * Get cookie data
   * @return array
   */
  getData() {

    let data = []

    if (designamite.getCookie(this.slug)) {
      data = JSON.parse(designamite.getCookie(this.slug))
    }
    
    return data

  },
  /** 
   * @param array - cookie data 
   * @return bool - cookie insert successful
   */
  insertData(data = []) {

    return designamite.setCookie(this.slug, JSON.stringify(data), 365)

  },
  /** 
   * add property id to cookie & update dom
   * @param string|int id property id
   * @param object el button
   * @return null
   */
  addItem(id, el) {

    if (id == null && id.length < 5) return

    let items = this.getData()

    if (items.indexOf(parseInt(id)) == -1) items.unshift(parseInt(id))

    if (items.length > 20) items.pop()

    this.insertData(items)

    this.updateDOM(true, el)

  },
  /**
   * remove property id
   * @param  int|string id property id
   * @param  object el button
   * @return null
   */
  removeItem(id, el) {

    let items = this.getData()

    let remove = items.filter(e => e !== parseInt(id))

    this.insertData(remove)

    if (el !== null) {

      this.updateDOM(false, el)

    }

  },
  /**
   * remove all cookie data
   * @return null
   */
  clearItems() {

    this.insertData()

  },
  /**
   * Update total html
   * @param  bool add - is/isn't already saved
   * @param  object el - button
   * @return null
   */
  updateDOM(add, el) {

    let items = this.getData(),
        total = items.length,
        buttonText = add ? 'Remove from favourites' : 'Add to favourites'

    $('.favourites-total').text(total)

    el.text(buttonText).attr('property-saved', add)

  },

}